import { HttpResponse, post } from '@/api/Api';
import { THGCarUpdateStatusPayload } from '@/interfaces/thg/THGCarUpdateStatusPayload';
import { TokenType } from '@/enums/TokenType';
import { THGInfoMailPayload } from '@/interfaces/thg/THGInfoMailPayload';
import {
    THGCarAddTagsPayload,
    THGCarOverrideCO2EquivalentPayload,
    THGCarOverrideStatusPayload,
    THGCarPayoutActionResponse,
    THGCarPayoutPayload,
    THGCarRenewPayload,
} from '@/interfaces/thg/THGCarActions';
import { processActionPayload } from '@/utils/thg';
import { api_url } from '@/api/thg/api';
import { THGActionResponse } from '@/interfaces/thg/THGActionResponse';

const CAR_ACTION_PATH = '/crm/car-actions';

/**
 * Trigger status update action.
 *
 * @param payload
 * @return response
 */
export async function triggerStatusUpdate(
    payload: THGCarUpdateStatusPayload,
): Promise<HttpResponse<THGActionResponse>> {
    const processedPayload = processActionPayload(payload);

    return await post<THGActionResponse>(
        `${api_url()}${CAR_ACTION_PATH}/update-status`,
        processedPayload,
        TokenType.THG_API_KEY,
    );
}

/**
 * Trigger info mail sending action.
 *
 * @param payload
 * @return response
 */
export async function triggerInfoMailSending(
    payload: THGInfoMailPayload,
): Promise<HttpResponse<THGActionResponse>> {
    const processedPayload = processActionPayload(payload);

    return await post<THGActionResponse>(
        `${api_url()}${CAR_ACTION_PATH}/send-info-mail`,
        processedPayload,
        TokenType.THG_API_KEY,
    );
}

/**
 * Trigger the PAYOUT action.
 *
 * @param payload
 * @return payload
 */
export async function triggerPayout(
    payload: THGCarPayoutPayload,
): Promise<HttpResponse<THGCarPayoutActionResponse>> {
    const processedPayload = processActionPayload(payload);

    return await post<THGCarPayoutActionResponse>(
        `${api_url()}${CAR_ACTION_PATH}/payout`,
        processedPayload,
        TokenType.THG_API_KEY,
    );
}

/**
 * Trigger an OVERRIDE-CO2-EQUIVALENT action.
 *
 * @param payload
 * @return payload
 */
export async function triggerOverrideCO2Equivalent(
    payload: THGCarOverrideCO2EquivalentPayload,
): Promise<HttpResponse<THGActionResponse>> {
    const processedPayload = processActionPayload(payload);

    return await post<THGActionResponse>(
        `${api_url()}${CAR_ACTION_PATH}/override-co2-equivalent`,
        processedPayload,
        TokenType.THG_API_KEY,
    );
}

/**
 * Trigger an OVERRIDE-STATUS action.
 *
 * @param payload
 * @return payload
 */
export async function triggerOverrideStatus(
    payload: THGCarOverrideStatusPayload,
): Promise<HttpResponse<THGActionResponse>> {
    const processedPayload = processActionPayload(payload);

    return await post<THGActionResponse>(
        `${api_url()}${CAR_ACTION_PATH}/override-status`,
        processedPayload,
        TokenType.THG_API_KEY,
    );
}

/**
 * Trigger a RENEW action.
 *
 * @param payload
 * @return payload
 */
export async function triggerRenew(
    payload: THGCarRenewPayload,
): Promise<HttpResponse<THGActionResponse>> {
    const processedPayload = processActionPayload(payload);

    return await post<THGActionResponse>(
        `${api_url()}${CAR_ACTION_PATH}/renew`,
        processedPayload,
        TokenType.THG_API_KEY,
    );
}

/**
 * Trigger an ADD-TAGS action.
 *
 * @param payload
 * @return payload
 */
export async function triggerAddTags(
    payload: THGCarAddTagsPayload,
): Promise<HttpResponse<THGActionResponse>> {
    const processedPayload = processActionPayload(payload);

    return await post<THGActionResponse>(
        `${api_url()}${CAR_ACTION_PATH}/add-tags`,
        processedPayload,
        TokenType.THG_API_KEY,
    );
}
